module.exports = __webpack_public_path__ + "static/media/ABC-zainab11.94b8ecd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABC-zainab11.png
// module id = 253
// module chunks = 17